import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CourseDetail51 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>詳細課程內容:</span>
        </h2>
        <p>
          這門詳盡的線性代數課程將引領您深入瞭解多個主題，包括機器學習中的
          <span>主成分分析（Principal Component Analysis, PCA）</span>、Python
          實作的圖像分析、馬可夫鏈、SVD分解、LU分解、QR分解、特徵值和特徵向量、施特拉森演算法、可逆矩陣的判斷以及Gershgorin圓定理。
        </p>
        <p>
          線性代數為電腦科學、資訊工程等領域的必修課程，其應用之廣泛，包含機器學習、深度學習、預測模型、電腦圖形處理以及加密系統等等。這堂線性代數課程內容包含基本的線性方程組的基本運算、向量空間、線性獨立、矩陣的可逆性、行列式、線性轉換、還有特徵矩陣以及特徵值的尋找，一步一步帶你認識所有重要的觀念、證明、運算過程與題目解答。不論你的數學基礎為何，都可以有系統性的認識線性代數中的重要理論、公式與計算原理。所有課程中所提到的公式與定理皆有證明過程與對應例子，讓學習有紮實基礎！
        </p>
      </motion.div>
    </div>
  );
};

export default CourseDetail51;
